package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.models.RubriqueCompetenceState
import io.horion.cv.styles.CompetenceFieldStyle
import io.horion.cv.styles.CompetenceFormContainerStyle
import io.horion.cv.styles.CompetenceLabelTextStyle
import io.horion.cv.styles.CompetenceRangeInputStyle
import io.horion.cv.styles.CompetenceValueTextStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label

@Composable
fun RubriqueCompetenceForm(
    state: RubriqueCompetenceState,
    onDelete: () -> Unit,
    onComplete: () -> Unit,
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Column(
        modifier = CompetenceFormContainerStyle.toModifier()
            .fillMaxWidth()
            .maxWidth(100.percent)
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
            }
    ) {

        TextFormField(
            label = "Compétence",
            value = state.competence,
            onValueChange = { state.competence = it },
            modifier = CompetenceFieldStyle.toModifier()
                .fillMaxWidth()
                .maxWidth(100.percent)
                .styleModifier {
                    property("box-sizing", "border-box")
                    property("min-width", "0")
                }
        )

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .styleModifier {
                    property("box-sizing", "border-box")
                    property("min-width", "0")
                },
            verticalArrangement = Arrangement.spacedBy(10.px)
        ) {

            Label {
                SpanText(
                    text = "Niveau",
                    modifier = CompetenceLabelTextStyle.toModifier()
                        .fontFamily(INTER)
                        .fontWeight(FontWeight.Light)
                        .color(
                            if (isDark) {
                                Colors.White
                            } else {
                                Colors.Primary
                            }
                        )
                )
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .styleModifier {
                        property("box-sizing", "border-box")
                        property("min-width", "0")
                    },
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(15.px)
            ) {

                Input(
                    type = InputType.Range,
                    attrs = CompetenceRangeInputStyle.toModifier()
                        .fillMaxWidth()
                        .styleModifier {
                            property("flex", "1")
                            property("min-width", "0")
                        }
                        .toAttrs {
                            attr("min", "0")
                            attr("max", "5")
                            attr("step", "1")

                            value(state.niveau.toString())

                            onInput { event ->
                                state.niveau =
                                    event.target.value.toIntOrNull() ?: 0
                            }
                        }
                )

                SpanText(
                    text = state.niveauLabel,
                    modifier = CompetenceValueTextStyle.toModifier()
                        .fontFamily(INTER)
                        .fontWeight(FontWeight.Medium)
                        .color(
                            if (state.niveau == 0) {
                                Colors.Placeholder
                            } else {
                                if (isDark) Colors.White else Colors.Primary
                            }
                        )
                )
            }
        }

        FormActionButtons(
            onDelete = onDelete,
            onComplete = onComplete
        )
    }
}